import React, { useState } from "react";
import style from "./home.module.css";
import MetricCard from "../components/metricCard";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  ArcElement,
} from "chart.js";
import { Line, Doughnut } from "react-chartjs-2";
import "chartjs-adapter-date-fns";
import { useDispatch, useSelector } from "react-redux";
import { increment } from "../redux/counterSlice";
import { useDashboardStatsQuery, useGetaccessTokenMutation } from "../redux/apislice";
import { Player } from "@lottiefiles/react-lottie-player";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  ArcElement
);

function DashBoard() {
  const [selectedMonth, setSelectedMonth] = useState("2024-01");
  const { data: apidash, isLoading } = useDashboardStatsQuery();
  console.log(apidash);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const getDaysOfMonth = (month) => {
    const [year, monthNumber] = month.split("-");
    const daysInMonth = new Date(year, monthNumber, 0).getDate();
    const days = [];
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(`${month}-${String(i).padStart(2, "0")}`);
    }
    return days;
  };

  const graphData = apidash?.data?.graph || [];

  const data = {
    labels: graphData.map((item) => {
      const [month, day] = item.name.split("/");
      return `2024-${month}-${day}`; 
    }),
    datasets: [
      {
        label: "Sales",
        data: graphData.map((item) => item.value),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
        borderColor: "rgba(255, 99, 132, 1)",
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: "day",
          displayFormats: {
            day: "MMM d",
          },
        },
        title: {
          display: true,
          text: "Date",
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(200, 200, 200, 0.2)",
        },
        title: {
          display: true,
          text: "Value",
        },
      },
    },
  };

  if (isLoading || !apidash) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
      }}>
        <Player
          autoplay
          loop
          src="https://assets1.lottiefiles.com/packages/lf20_raiw2hpe.json"
          style={{ height: '150px', width: '150px' }}
        >
        </Player>
      </div>
    );
  }

  return (
    <div className={style.rightSide}>
      <span className={style.label}>Dashboard</span>
      <div className={style.cards}>
        <MetricCard
          title={"Total Orders"}
          value={apidash?.data?.totalOrders}
          growth={"8.5%"}
          growthText={"Number of orders placed."}
        />
        <MetricCard
          title={"Total Sales"}
          value={apidash?.data?.totalSales}
          growth={"8.5%"}
          growthText={"Up from yesterday"}
        />
        <MetricCard
          title={"Total Products"}
          value={apidash?.data?.totalproducts}
          growth={"8.5%"}
          growthText={"Up from yesterday"}
        />
      </div>

      <div className={`${style.viewSelect}  ${style.mobileHidden}`}>
        <select value={selectedMonth} onChange={handleMonthChange}>
          <option value="2024-01">January</option>
          <option value="2024-02">February</option>
          <option value="2024-03">March</option>
          <option value="2024-04">April</option>
          <option value="2024-05">May</option>
          <option value="2024-06">June</option>
          <option value="2024-07">July</option>
          <option value="2024-08">August</option>
          <option value="2024-09">September</option>
          <option value="2024-10">October</option>
          <option value="2024-11">November</option>
          <option value="2024-12">December</option>
        </select>
      </div>

      <div className={`${style.lineGraph} ${style.mobileHidden}`}>
        <Line options={options} data={data} />
      </div>

      <style jsx>{`
        @media (max-width: 768px) {
          .${style.mobileHidden} {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
}

export default DashBoard;